export const cities = [
  {
    "name": "Berlin",
    "slug": "berlin",
    "state": "Berlin",
    "zipCodes": "10115-14199",
    "region": "Hauptstadt",
    "description": "Als Hauptstadt und größte Region Deutschlands bieten wir in Berlin umfassende Wärmepumpen-Lösungen für Privat- und Geschäftskunden.",
    "heroTitle": "Wärmepumpen in Berlin – Ihr Experte für nachhaltige Heizlösungen",
    "seoKeywords": "Wärmepumpe Berlin, Heizung Berlin, Wärmepumpeninstallation Berlin"
  },
  {
    "name": "Hamburg",
    "slug": "hamburg",
    "state": "Hamburg",
    "zipCodes": "20095-22769",
    "region": "Hansestadt",
    "description": "In der Hansestadt Hamburg setzen wir auf moderne Wärmepumpentechnologie für effizientes und umweltfreundliches Heizen.",
    "heroTitle": "Wärmepumpen in Hamburg – Nachhaltig heizen in der Hansestadt",
    "seoKeywords": "Wärmepumpe Hamburg, Heizung Hamburg, Wärmepumpeninstallation Hamburg"
  },
  {
    "name": "München",
    "slug": "muenchen",
    "state": "Bayern",
    "zipCodes": "80331-81929",
    "region": "Landeshauptstadt Bayern",
    "description": "In München und Umgebung sind wir Ihr kompetenter Partner für die Installation und Wartung moderner Wärmepumpen.",
    "heroTitle": "Wärmepumpen in München – Ihr Heizungsexperte in Bayern",
    "seoKeywords": "Wärmepumpe München, Heizung München, Wärmepumpeninstallation München"
  },
  {
    "name": "Köln",
    "slug": "koeln",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "50259, 50321, 50374, 50667-51149",
    "region": "Rheinland",
    "description": "Für Köln und das Rheinland bieten wir professionelle Wärmepumpen-Lösungen mit erstklassigem Service.",
    "heroTitle": "Wärmepumpen in Köln – Heizungsexperten im Rheinland",
    "seoKeywords": "Wärmepumpe Köln, Heizung Köln, Wärmepumpeninstallation Köln"
  },
  {
    "name": "Frankfurt am Main",
    "slug": "frankfurt",
    "state": "Hessen",
    "zipCodes": "60306-65936, 64331",
    "region": "Finanzmetropole",
    "description": "In Frankfurt am Main und dem Rhein-Main-Gebiet installieren wir energieeffiziente Wärmepumpen für jeden Bedarf.",
    "heroTitle": "Wärmepumpen in Frankfurt – Moderne Heiztechnik im Rhein-Main-Gebiet",
    "seoKeywords": "Wärmepumpe Frankfurt, Heizung Frankfurt, Wärmepumpeninstallation Frankfurt"
  },
  {
    "name": "Stuttgart",
    "slug": "stuttgart",
    "state": "Baden-Württemberg",
    "zipCodes": "70173-70619",
    "region": "Landeshauptstadt Baden-Württemberg",
    "description": "In Stuttgart und der Region bieten wir innovative Wärmepumpen-Systeme für nachhaltiges Heizen.",
    "heroTitle": "Wärmepumpen in Stuttgart – Ihr Partner in Baden-Württemberg",
    "seoKeywords": "Wärmepumpe Stuttgart, Heizung Stuttgart, Wärmepumpeninstallation Stuttgart"
  },
  {
    "name": "Düsseldorf",
    "slug": "duesseldorf",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "40210-40629",
    "region": "Landeshauptstadt NRW",
    "description": "In Düsseldorf sind wir Ihr zuverlässiger Partner für moderne Wärmepumpentechnologie.",
    "heroTitle": "Wärmepumpen in Düsseldorf – Heizungsexperten in der Landeshauptstadt NRW",
    "seoKeywords": "Wärmepumpe Düsseldorf, Heizung Düsseldorf, Wärmepumpeninstallation Düsseldorf"
  },
  {
    "name": "Dortmund",
    "slug": "dortmund",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "44135-44388",
    "region": "Ruhrgebiet",
    "description": "Im Herzen des Ruhrgebiets bieten wir professionelle Wärmepumpen-Installationen in Dortmund.",
    "heroTitle": "Wärmepumpen in Dortmund – Moderne Heizlösungen im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Dortmund, Heizung Dortmund, Wärmepumpeninstallation Dortmund"
  },
  {
    "name": "Essen",
    "slug": "essen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "45127-45359",
    "region": "Ruhrgebiet",
    "description": "In Essen installieren wir energieeffiziente Wärmepumpen für Wohn- und Gewerbeimmobilien.",
    "heroTitle": "Wärmepumpen in Essen – Ihr Heizungsexperte im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Essen, Heizung Essen, Wärmepumpeninstallation Essen"
  },
  {
    "name": "Leipzig",
    "slug": "leipzig",
    "state": "Sachsen",
    "zipCodes": "04103-04357",
    "region": "Sachsen",
    "description": "In Leipzig und Umgebung sind wir Ihr kompetenter Ansprechpartner für nachhaltige Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Leipzig – Heizungsexperten in Sachsen",
    "seoKeywords": "Wärmepumpe Leipzig, Heizung Leipzig, Wärmepumpeninstallation Leipzig"
  },
  {
    "name": "Bremen",
    "slug": "bremen",
    "state": "Bremen",
    "zipCodes": "28195-28779",
    "region": "Hansestadt",
    "description": "In der Hansestadt Bremen bieten wir professionelle Wärmepumpen-Lösungen mit bestem Service.",
    "heroTitle": "Wärmepumpen in Bremen – Nachhaltig heizen in der Hansestadt",
    "seoKeywords": "Wärmepumpe Bremen, Heizung Bremen, Wärmepumpeninstallation Bremen"
  },
  {
    "name": "Dresden",
    "slug": "dresden",
    "state": "Sachsen",
    "zipCodes": "01067-01328",
    "region": "Landeshauptstadt Sachsen",
    "description": "In Dresden installieren wir moderne Wärmepumpen für energieeffizientes Heizen in Sachsen.",
    "heroTitle": "Wärmepumpen in Dresden – Ihr Partner in der sächsischen Landeshauptstadt",
    "seoKeywords": "Wärmepumpe Dresden, Heizung Dresden, Wärmepumpeninstallation Dresden"
  },
  {
    "name": "Hannover",
    "slug": "hannover",
    "state": "Niedersachsen",
    "zipCodes": "30159-30669, 30851-30855",
    "region": "Landeshauptstadt Niedersachsen",
    "description": "In Hannover und Niedersachsen bieten wir erstklassige Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Hannover – Heizungsexperten in Niedersachsen",
    "seoKeywords": "Wärmepumpe Hannover, Heizung Hannover, Wärmepumpeninstallation Hannover"
  },
  {
    "name": "Nürnberg",
    "slug": "nuernberg",
    "state": "Bayern",
    "zipCodes": "90402-90491",
    "region": "Franken",
    "description": "In Nürnberg und Franken sind wir Ihr zuverlässiger Partner für Wärmepumpentechnologie.",
    "heroTitle": "Wärmepumpen in Nürnberg – Moderne Heizlösungen in Franken",
    "seoKeywords": "Wärmepumpe Nürnberg, Heizung Nürnberg, Wärmepumpeninstallation Nürnberg"
  },
  {
    "name": "Duisburg",
    "slug": "duisburg",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "47051-47259",
    "region": "Ruhrgebiet",
    "description": "In Duisburg installieren wir umweltfreundliche Wärmepumpen für nachhaltiges Heizen.",
    "heroTitle": "Wärmepumpen in Duisburg – Ihr Heizungsexperte im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Duisburg, Heizung Duisburg, Wärmepumpeninstallation Duisburg"
  },
  {
    "name": "Bochum",
    "slug": "bochum",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "44787-44894",
    "region": "Ruhrgebiet",
    "description": "In Bochum bieten wir professionelle Wärmepumpen-Lösungen für jeden Bedarf.",
    "heroTitle": "Wärmepumpen in Bochum – Nachhaltig heizen im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Bochum, Heizung Bochum, Wärmepumpeninstallation Bochum"
  },
  {
    "name": "Wuppertal",
    "slug": "wuppertal",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "42103-42399",
    "region": "Bergisches Land",
    "description": "Im Bergischen Land installieren wir moderne Wärmepumpen in Wuppertal und Umgebung.",
    "heroTitle": "Wärmepumpen in Wuppertal – Heizungsexperten im Bergischen Land",
    "seoKeywords": "Wärmepumpe Wuppertal, Heizung Wuppertal, Wärmepumpeninstallation Wuppertal"
  },
  {
    "name": "Bielefeld",
    "slug": "bielefeld",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "32756-32760, 33602-33739",
    "region": "Ostwestfalen",
    "description": "In Bielefeld und Ostwestfalen sind wir Ihr kompetenter Partner für Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Bielefeld – Moderne Heizlösungen in Ostwestfalen",
    "seoKeywords": "Wärmepumpe Bielefeld, Heizung Bielefeld, Wärmepumpeninstallation Bielefeld"
  },
  {
    "name": "Bonn",
    "slug": "bonn",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "53111-53229, 53879",
    "region": "Rheinland",
    "description": "In Bonn installieren wir energieeffiziente Wärmepumpen für nachhaltiges Heizen.",
    "heroTitle": "Wärmepumpen in Bonn – Ihr Partner am Rhein",
    "seoKeywords": "Wärmepumpe Bonn, Heizung Bonn, Wärmepumpeninstallation Bonn"
  },
  {
    "name": "Münster",
    "slug": "muenster",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "48143-48167",
    "region": "Münsterland",
    "description": "Im Münsterland bieten wir professionelle Wärmepumpen-Installationen in Münster.",
    "heroTitle": "Wärmepumpen in Münster – Heizungsexperten im Münsterland",
    "seoKeywords": "Wärmepumpe Münster, Heizung Münster, Wärmepumpeninstallation Münster"
  },
  {
    "name": "Karlsruhe",
    "slug": "karlsruhe",
    "state": "Baden-Württemberg",
    "zipCodes": "76131-76229",
    "region": "Baden",
    "description": "In Karlsruhe und der Region installieren wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Karlsruhe – Moderne Heizlösungen in Baden",
    "seoKeywords": "Wärmepumpe Karlsruhe, Heizung Karlsruhe, Wärmepumpeninstallation Karlsruhe"
  },
  {
    "name": "Mannheim",
    "slug": "mannheim",
    "state": "Baden-Württemberg",
    "zipCodes": "68159-68309",
    "region": "Rhein-Neckar",
    "description": "In Mannheim und der Rhein-Neckar-Region sind wir Ihr Wärmepumpen-Experte.",
    "heroTitle": "Wärmepumpen in Mannheim – Ihr Partner in der Rhein-Neckar-Region",
    "seoKeywords": "Wärmepumpe Mannheim, Heizung Mannheim, Wärmepumpeninstallation Mannheim"
  },
  {
    "name": "Augsburg",
    "slug": "augsburg",
    "state": "Bayern",
    "zipCodes": "86150-86199",
    "region": "Schwaben",
    "description": "In Augsburg und Schwaben installieren wir energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Augsburg – Heizungsexperten in Schwaben",
    "seoKeywords": "Wärmepumpe Augsburg, Heizung Augsburg, Wärmepumpeninstallation Augsburg"
  },
  {
    "name": "Wiesbaden",
    "slug": "wiesbaden",
    "state": "Hessen",
    "zipCodes": "65183-65207",
    "region": "Landeshauptstadt Hessen",
    "description": "In Wiesbaden bieten wir professionelle Wärmepumpen-Lösungen für die hessische Landeshauptstadt.",
    "heroTitle": "Wärmepumpen in Wiesbaden – Nachhaltig heizen in Hessen",
    "seoKeywords": "Wärmepumpe Wiesbaden, Heizung Wiesbaden, Wärmepumpeninstallation Wiesbaden"
  },
  {
    "name": "Gelsenkirchen",
    "slug": "gelsenkirchen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "45699, 45879-45899",
    "region": "Ruhrgebiet",
    "description": "In Gelsenkirchen installieren wir moderne Wärmepumpen im Ruhrgebiet.",
    "heroTitle": "Wärmepumpen in Gelsenkirchen – Heizungsexperten im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Gelsenkirchen, Heizung Gelsenkirchen, Wärmepumpeninstallation Gelsenkirchen"
  },
  {
    "name": "Mönchengladbach",
    "slug": "moenchengladbach",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "41061-41239",
    "region": "Niederrhein",
    "description": "Am Niederrhein bieten wir in Mönchengladbach erstklassige Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Mönchengladbach – Ihr Partner am Niederrhein",
    "seoKeywords": "Wärmepumpe Mönchengladbach, Heizung Mönchengladbach, Wärmepumpeninstallation Mönchengladbach"
  },
  {
    "name": "Braunschweig",
    "slug": "braunschweig",
    "state": "Niedersachsen",
    "zipCodes": "38100-38126",
    "region": "Niedersachsen",
    "description": "In Braunschweig installieren wir moderne Wärmepumpen für nachhaltiges Heizen.",
    "heroTitle": "Wärmepumpen in Braunschweig – Heizungsexperten in Niedersachsen",
    "seoKeywords": "Wärmepumpe Braunschweig, Heizung Braunschweig, Wärmepumpeninstallation Braunschweig"
  },
  {
    "name": "Chemnitz",
    "slug": "chemnitz",
    "state": "Sachsen",
    "zipCodes": "09111-09134",
    "region": "Sachsen",
    "description": "In Chemnitz sind wir Ihr zuverlässiger Partner für Wärmepumpentechnologie in Sachsen.",
    "heroTitle": "Wärmepumpen in Chemnitz – Moderne Heizlösungen in Sachsen",
    "seoKeywords": "Wärmepumpe Chemnitz, Heizung Chemnitz, Wärmepumpeninstallation Chemnitz"
  },
  {
    "name": "Kiel",
    "slug": "kiel",
    "state": "Schleswig-Holstein",
    "zipCodes": "24103-24159",
    "region": "Landeshauptstadt Schleswig-Holstein",
    "description": "An der Ostseeküste bieten wir in Kiel professionelle Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Kiel – Ihr Partner in Schleswig-Holstein",
    "seoKeywords": "Wärmepumpe Kiel, Heizung Kiel, Wärmepumpeninstallation Kiel"
  },
  {
    "name": "Aachen",
    "slug": "aachen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "52062-52080",
    "region": "Aachener Raum",
    "description": "In Aachen und der Euregio installieren wir energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Aachen – Heizungsexperten in der Kaiserstadt",
    "seoKeywords": "Wärmepumpe Aachen, Heizung Aachen, Wärmepumpeninstallation Aachen"
  },
  {
    "name": "Halle (Saale)",
    "slug": "halle",
    "state": "Sachsen-Anhalt",
    "zipCodes": "06108-06132",
    "region": "Sachsen-Anhalt",
    "description": "In Halle an der Saale bieten wir moderne Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Halle – Ihr Partner in Sachsen-Anhalt",
    "seoKeywords": "Wärmepumpe Halle, Heizung Halle, Wärmepumpeninstallation Halle"
  },
  {
    "name": "Magdeburg",
    "slug": "magdeburg",
    "state": "Sachsen-Anhalt",
    "zipCodes": "39104-39130",
    "region": "Landeshauptstadt Sachsen-Anhalt",
    "description": "In der Landeshauptstadt Magdeburg sind wir Ihr kompetenter Wärmepumpen-Partner.",
    "heroTitle": "Wärmepumpen in Magdeburg – Heizungsexperten in Sachsen-Anhalt",
    "seoKeywords": "Wärmepumpe Magdeburg, Heizung Magdeburg, Wärmepumpeninstallation Magdeburg"
  },
  {
    "name": "Freiburg im Breisgau",
    "slug": "freiburg",
    "state": "Baden-Württemberg",
    "zipCodes": "79098-79117",
    "region": "Schwarzwald",
    "description": "In Freiburg und dem Schwarzwald installieren wir nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Freiburg – Nachhaltig heizen im Schwarzwald",
    "seoKeywords": "Wärmepumpe Freiburg, Heizung Freiburg, Wärmepumpeninstallation Freiburg"
  },
  {
    "name": "Krefeld",
    "slug": "krefeld",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "47798-47829",
    "region": "Niederrhein",
    "description": "In Krefeld am Niederrhein bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Krefeld – Ihr Partner am Niederrhein",
    "seoKeywords": "Wärmepumpe Krefeld, Heizung Krefeld, Wärmepumpeninstallation Krefeld"
  },
  {
    "name": "Lübeck",
    "slug": "luebeck",
    "state": "Schleswig-Holstein",
    "zipCodes": "23552-23570",
    "region": "Hansestadt",
    "description": "In der Hansestadt Lübeck installieren wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Lübeck – Heizungsexperten in der Hansestadt",
    "seoKeywords": "Wärmepumpe Lübeck, Heizung Lübeck, Wärmepumpeninstallation Lübeck"
  },
  {
    "name": "Oberhausen",
    "slug": "oberhausen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "46045-46149",
    "region": "Ruhrgebiet",
    "description": "In Oberhausen bieten wir energieeffiziente Wärmepumpen für das Ruhrgebiet.",
    "heroTitle": "Wärmepumpen in Oberhausen – Moderne Heizlösungen im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Oberhausen, Heizung Oberhausen, Wärmepumpeninstallation Oberhausen"
  },
  {
    "name": "Erfurt",
    "slug": "erfurt",
    "state": "Thüringen",
    "zipCodes": "99084-99099",
    "region": "Landeshauptstadt Thüringen",
    "description": "In Erfurt sind wir Ihr zuverlässiger Partner für Wärmepumpen in Thüringen.",
    "heroTitle": "Wärmepumpen in Erfurt – Heizungsexperten in Thüringen",
    "seoKeywords": "Wärmepumpe Erfurt, Heizung Erfurt, Wärmepumpeninstallation Erfurt"
  },
  {
    "name": "Mainz",
    "slug": "mainz",
    "state": "Rheinland-Pfalz",
    "zipCodes": "55116-55131",
    "region": "Landeshauptstadt Rheinland-Pfalz",
    "description": "In Mainz bieten wir professionelle Wärmepumpen-Lösungen für Rheinland-Pfalz.",
    "heroTitle": "Wärmepumpen in Mainz – Ihr Partner in Rheinland-Pfalz",
    "seoKeywords": "Wärmepumpe Mainz, Heizung Mainz, Wärmepumpeninstallation Mainz"
  },
  {
    "name": "Rostock",
    "slug": "rostock",
    "state": "Mecklenburg-Vorpommern",
    "zipCodes": "18055-18147",
    "region": "Hansestadt",
    "description": "An der Ostsee installieren wir in Rostock moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Rostock – Heizungsexperten an der Ostsee",
    "seoKeywords": "Wärmepumpe Rostock, Heizung Rostock, Wärmepumpeninstallation Rostock"
  },
  {
    "name": "Kassel",
    "slug": "kassel",
    "state": "Hessen",
    "zipCodes": "34117-34134",
    "region": "Nordhessen",
    "description": "In Kassel und Nordhessen sind wir Ihr kompetenter Wärmepumpen-Partner.",
    "heroTitle": "Wärmepumpen in Kassel – Moderne Heizlösungen in Nordhessen",
    "seoKeywords": "Wärmepumpe Kassel, Heizung Kassel, Wärmepumpeninstallation Kassel"
  },
  {
    "name": "Hagen",
    "slug": "hagen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "58089-58135",
    "region": "Südwestfalen",
    "description": "In Hagen installieren wir energieeffiziente Wärmepumpen für Südwestfalen.",
    "heroTitle": "Wärmepumpen in Hagen – Ihr Partner in Südwestfalen",
    "seoKeywords": "Wärmepumpe Hagen, Heizung Hagen, Wärmepumpeninstallation Hagen"
  },
  {
    "name": "Hamm",
    "slug": "hamm",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "59065-59077, 59192",
    "region": "Westfalen",
    "description": "In Hamm bieten wir professionelle Wärmepumpen-Installationen in Westfalen.",
    "heroTitle": "Wärmepumpen in Hamm – Heizungsexperten in Westfalen",
    "seoKeywords": "Wärmepumpe Hamm, Heizung Hamm, Wärmepumpeninstallation Hamm"
  },
  {
    "name": "Saarbrücken",
    "slug": "saarbruecken",
    "state": "Saarland",
    "zipCodes": "66111-66133",
    "region": "Landeshauptstadt Saarland",
    "description": "Im Saarland installieren wir in Saarbrücken moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Saarbrücken – Ihr Partner im Saarland",
    "seoKeywords": "Wärmepumpe Saarbrücken, Heizung Saarbrücken, Wärmepumpeninstallation Saarbrücken"
  },
  {
    "name": "Mülheim an der Ruhr",
    "slug": "muelheim",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "45468-45481",
    "region": "Ruhrgebiet",
    "description": "In Mülheim an der Ruhr bieten wir energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Mülheim – Moderne Heizlösungen im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Mülheim, Heizung Mülheim, Wärmepumpeninstallation Mülheim"
  },
  {
    "name": "Potsdam",
    "slug": "potsdam",
    "state": "Brandenburg",
    "zipCodes": "14467-14482",
    "region": "Landeshauptstadt Brandenburg",
    "description": "In Potsdam und Brandenburg sind wir Ihr kompetenter Wärmepumpen-Partner.",
    "heroTitle": "Wärmepumpen in Potsdam – Heizungsexperten in Brandenburg",
    "seoKeywords": "Wärmepumpe Potsdam, Heizung Potsdam, Wärmepumpeninstallation Potsdam"
  },
  {
    "name": "Ludwigshafen",
    "slug": "ludwigshafen",
    "state": "Rheinland-Pfalz",
    "zipCodes": "67059-67071",
    "region": "Rhein-Neckar",
    "description": "In Ludwigshafen installieren wir moderne Wärmepumpen in der Rhein-Neckar-Region.",
    "heroTitle": "Wärmepumpen in Ludwigshafen – Ihr Partner am Rhein",
    "seoKeywords": "Wärmepumpe Ludwigshafen, Heizung Ludwigshafen, Wärmepumpeninstallation Ludwigshafen"
  },
  {
    "name": "Oldenburg",
    "slug": "oldenburg",
    "state": "Niedersachsen",
    "zipCodes": "26121-26135",
    "region": "Niedersachsen",
    "description": "In Oldenburg bieten wir professionelle Wärmepumpen-Lösungen für Niedersachsen.",
    "heroTitle": "Wärmepumpen in Oldenburg – Heizungsexperten in Niedersachsen",
    "seoKeywords": "Wärmepumpe Oldenburg, Heizung Oldenburg, Wärmepumpeninstallation Oldenburg"
  },
  {
    "name": "Leverkusen",
    "slug": "leverkusen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "51365-51381",
    "region": "Rheinland",
    "description": "In Leverkusen installieren wir energieeffiziente Wärmepumpen im Rheinland.",
    "heroTitle": "Wärmepumpen in Leverkusen – Moderne Heizlösungen im Rheinland",
    "seoKeywords": "Wärmepumpe Leverkusen, Heizung Leverkusen, Wärmepumpeninstallation Leverkusen"
  },
  {
    "name": "Osnabrück",
    "slug": "osnabrueck",
    "state": "Niedersachsen",
    "zipCodes": "49074-49090",
    "region": "Niedersachsen",
    "description": "In Osnabrück sind wir Ihr zuverlässiger Partner für Wärmepumpentechnologie.",
    "heroTitle": "Wärmepumpen in Osnabrück – Ihr Partner in Niedersachsen",
    "seoKeywords": "Wärmepumpe Osnabrück, Heizung Osnabrück, Wärmepumpeninstallation Osnabrück"
  },
  {
    "name": "Solingen",
    "slug": "solingen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "42651-42719",
    "region": "Bergisches Land",
    "description": "Im Bergischen Land bieten wir in Solingen professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Solingen – Heizungsexperten im Bergischen Land",
    "seoKeywords": "Wärmepumpe Solingen, Heizung Solingen, Wärmepumpeninstallation Solingen"
  },
  {
    "name": "Heidelberg",
    "slug": "heidelberg",
    "state": "Baden-Württemberg",
    "zipCodes": "69115-69126",
    "region": "Kurpfalz",
    "description": "In Heidelberg sind wir Ihr Experte für moderne Wärmepumpen-Technologie.",
    "heroTitle": "Wärmepumpen in Heidelberg – Nachhaltig heizen in der Kurpfalz",
    "seoKeywords": "Wärmepumpe Heidelberg, Heizung Heidelberg, Wärmepumpeninstallation Heidelberg"
  },
  {
    "name": "Pforzheim",
    "slug": "pforzheim",
    "state": "Baden-Württemberg",
    "zipCodes": "75172-75181",
    "region": "Nordschwarzwald",
    "description": "In Pforzheim installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Pforzheim – Ihr Heizungsexperte im Schwarzwald",
    "seoKeywords": "Wärmepumpe Pforzheim, Heizung Pforzheim, Wärmepumpeninstallation Pforzheim"
  },
  {
    "name": "Reutlingen",
    "slug": "reutlingen",
    "state": "Baden-Württemberg",
    "zipCodes": "72760-72770",
    "region": "Neckar-Alb",
    "description": "In Reutlingen bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Reutlingen – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Reutlingen, Heizung Reutlingen, Wärmepumpeninstallation Reutlingen"
  },
  {
    "name": "Heilbronn",
    "slug": "heilbronn",
    "state": "Baden-Württemberg",
    "zipCodes": "74072-74081",
    "region": "Heilbronn-Franken",
    "description": "In Heilbronn sind wir Ihr Partner für energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Heilbronn – Heizungsexperten in der Region",
    "seoKeywords": "Wärmepumpe Heilbronn, Heizung Heilbronn, Wärmepumpeninstallation Heilbronn"
  },
  {
    "name": "Ulm",
    "slug": "ulm",
    "state": "Baden-Württemberg",
    "zipCodes": "89073-89081",
    "region": "Oberschwaben",
    "description": "In Ulm an der Donau installieren wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Ulm – Ihr Experte an der Donau",
    "seoKeywords": "Wärmepumpe Ulm, Heizung Ulm, Wärmepumpeninstallation Ulm"
  },
  {
    "name": "Ingolstadt",
    "slug": "ingolstadt",
    "state": "Bayern",
    "zipCodes": "85049-85057",
    "region": "Oberbayern",
    "description": "In Ingolstadt bieten wir nachhaltige Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Ingolstadt – Moderne Heiztechnik in Bayern",
    "seoKeywords": "Wärmepumpe Ingolstadt, Heizung Ingolstadt, Wärmepumpeninstallation Ingolstadt"
  },
  {
    "name": "Fürth",
    "slug": "fuerth",
    "state": "Bayern",
    "zipCodes": "90762-90768",
    "region": "Mittelfranken",
    "description": "In Fürth installieren wir energieeffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Fürth – Heizen mit Zukunft",
    "seoKeywords": "Wärmepumpe Fürth, Heizung Fürth, Wärmepumpeninstallation Fürth"
  },
  {
    "name": "Würzburg",
    "slug": "wuerzburg",
    "state": "Bayern",
    "zipCodes": "97070-97084",
    "region": "Unterfranken",
    "description": "In Würzburg sind wir Ihr kompetenter Partner für Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Würzburg – Ihr Heizungsexperte in Unterfranken",
    "seoKeywords": "Wärmepumpe Würzburg, Heizung Würzburg, Wärmepumpeninstallation Würzburg"
  },
  {
    "name": "Regensburg",
    "slug": "regensburg",
    "state": "Bayern",
    "zipCodes": "93047-93059",
    "region": "Oberpfalz",
    "description": "In Regensburg bieten wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Regensburg – Nachhaltig heizen in der Oberpfalz",
    "seoKeywords": "Wärmepumpe Regensburg, Heizung Regensburg, Wärmepumpeninstallation Regensburg"
  },
  {
    "name": "Erlangen",
    "slug": "erlangen",
    "state": "Bayern",
    "zipCodes": "91052-91058",
    "region": "Mittelfranken",
    "description": "In Erlangen installieren wir hocheffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Erlangen – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Erlangen, Heizung Erlangen, Wärmepumpeninstallation Erlangen"
  },
  {
    "name": "Göttingen",
    "slug": "goettingen",
    "state": "Niedersachsen",
    "zipCodes": "37073-37085",
    "region": "Südniedersachsen",
    "description": "In Göttingen sind wir Ihr Partner für nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Göttingen – Heizungsexperten in Südniedersachsen",
    "seoKeywords": "Wärmepumpe Göttingen, Heizung Göttingen, Wärmepumpeninstallation Göttingen"
  },
  {
    "name": "Salzgitter",
    "slug": "salzgitter",
    "state": "Niedersachsen",
    "zipCodes": "38226-38259",
    "region": "Südostniedersachsen",
    "description": "In Salzgitter bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Salzgitter – Ihr Heizungsexperte",
    "seoKeywords": "Wärmepumpe Salzgitter, Heizung Salzgitter, Wärmepumpeninstallation Salzgitter"
  },
  {
    "name": "Hildesheim",
    "slug": "hildesheim",
    "state": "Niedersachsen",
    "zipCodes": "31134-31141",
    "region": "Südniedersachsen",
    "description": "In Hildesheim installieren wir energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Hildesheim – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Hildesheim, Heizung Hildesheim, Wärmepumpeninstallation Hildesheim"
  },
  {
    "name": "Kaiserslautern",
    "slug": "kaiserslautern",
    "state": "Rheinland-Pfalz",
    "zipCodes": "67655-67663",
    "region": "Pfalz",
    "description": "In Kaiserslautern bieten wir nachhaltige Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Kaiserslautern – Heizen mit Zukunft",
    "seoKeywords": "Wärmepumpe Kaiserslautern, Heizung Kaiserslautern, Wärmepumpeninstallation Kaiserslautern"
  },
  {
    "name": "Witten",
    "slug": "witten",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "58452-58456",
    "region": "Ruhrgebiet",
    "description": "In Witten sind wir Ihr Experte für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Witten – Ihr Partner im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Witten, Heizung Witten, Wärmepumpeninstallation Witten"
  },
  {
    "name": "Gütersloh",
    "slug": "guetersloh",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "33330-33335",
    "region": "Ostwestfalen",
    "description": "In Gütersloh installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Gütersloh – Heizungsexperten in Ostwestfalen",
    "seoKeywords": "Wärmepumpe Gütersloh, Heizung Gütersloh, Wärmepumpeninstallation Gütersloh"
  },
  {
    "name": "Iserlohn",
    "slug": "iserlohn",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "58636-58644",
    "region": "Sauerland",
    "description": "In Iserlohn bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Iserlohn – Moderne Heiztechnik im Sauerland",
    "seoKeywords": "Wärmepumpe Iserlohn, Heizung Iserlohn, Wärmepumpeninstallation Iserlohn"
  },
  {
    "name": "Schwerin",
    "slug": "schwerin",
    "state": "Mecklenburg-Vorpommern",
    "zipCodes": "19053-19063",
    "region": "Landeshauptstadt MV",
    "description": "In Schwerin sind wir Ihr Partner für nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Schwerin – Heizungsexperten in Mecklenburg",
    "seoKeywords": "Wärmepumpe Schwerin, Heizung Schwerin, Wärmepumpeninstallation Schwerin"
  },
  {
    "name": "Cottbus",
    "slug": "cottbus",
    "state": "Brandenburg",
    "zipCodes": "03042-03055",
    "region": "Lausitz",
    "description": "In Cottbus installieren wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Cottbus – Ihr Experte in der Lausitz",
    "seoKeywords": "Wärmepumpe Cottbus, Heizung Cottbus, Wärmepumpeninstallation Cottbus"
  },
  {
    "name": "Gera",
    "slug": "gera",
    "state": "Thüringen",
    "zipCodes": "07545-07557",
    "region": "Ostthüringen",
    "description": "In Gera bieten wir energieeffiziente Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Gera – Heizen mit Zukunft in Thüringen",
    "seoKeywords": "Wärmepumpe Gera, Heizung Gera, Wärmepumpeninstallation Gera"
  },
  {
    "name": "Hanau",
    "slug": "hanau",
    "state": "Hessen",
    "zipCodes": "63450-63457",
    "region": "Main-Kinzig",
    "description": "In Hanau am Main installieren wir nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Hanau – Moderne Heiztechnik am Main",
    "seoKeywords": "Wärmepumpe Hanau, Heizung Hanau, Wärmepumpeninstallation Hanau"
  },
  {
    "name": "Esslingen",
    "slug": "esslingen",
    "state": "Baden-Württemberg",
    "zipCodes": "73728-73734",
    "region": "Neckar",
    "description": "In Esslingen bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Esslingen – Ihr Partner am Neckar",
    "seoKeywords": "Wärmepumpe Esslingen, Heizung Esslingen, Wärmepumpeninstallation Esslingen"
  },
  {
    "name": "Tübingen",
    "slug": "tuebingen",
    "state": "Baden-Württemberg",
    "zipCodes": "72070-72076",
    "region": "Neckar-Alb",
    "description": "In Tübingen sind wir Ihr Experte für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Tübingen – Heizungsexperten in der Universitätsstadt",
    "seoKeywords": "Wärmepumpe Tübingen, Heizung Tübingen, Wärmepumpeninstallation Tübingen"
  },
  {
    "name": "Flensburg",
    "slug": "flensburg",
    "state": "Schleswig-Holstein",
    "zipCodes": "24937-24944",
    "region": "Grenzregion",
    "description": "In Flensburg bieten wir nachhaltige Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Flensburg – Heizen mit Zukunft im Norden",
    "seoKeywords": "Wärmepumpe Flensburg, Heizung Flensburg, Wärmepumpeninstallation Flensburg"
  },
  {
    "name": "Konstanz",
    "slug": "konstanz",
    "state": "Baden-Württemberg",
    "zipCodes": "78462-78467",
    "region": "Bodensee",
    "description": "In Konstanz am Bodensee installieren wir moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Konstanz – Ihr Partner am Bodensee",
    "seoKeywords": "Wärmepumpe Konstanz, Heizung Konstanz, Wärmepumpeninstallation Konstanz"
  },
  {
    "name": "Worms",
    "slug": "worms",
    "state": "Rheinland-Pfalz",
    "zipCodes": "67547-67551",
    "region": "Rheinhessen",
    "description": "In Worms bieten wir energieeffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Worms – Moderne Heiztechnik in Rheinhessen",
    "seoKeywords": "Wärmepumpe Worms, Heizung Worms, Wärmepumpeninstallation Worms"
  },
  {
    "name": "Lüneburg",
    "slug": "lueneburg",
    "state": "Niedersachsen",
    "zipCodes": "21335-21339",
    "region": "Heide",
    "description": "In Lüneburg sind wir Ihr Partner für nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Lüneburg – Heizungsexperten in der Heide",
    "seoKeywords": "Wärmepumpe Lüneburg, Heizung Lüneburg, Wärmepumpeninstallation Lüneburg"
  },
  {
    "name": "Marburg",
    "slug": "marburg",
    "state": "Hessen",
    "zipCodes": "35037-35043",
    "region": "Mittelhessen",
    "description": "In Marburg installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Marburg – Moderne Heiztechnik in Mittelhessen",
    "seoKeywords": "Wärmepumpe Marburg, Heizung Marburg, Wärmepumpeninstallation Marburg"
  },
  {
    "name": "Bayreuth",
    "slug": "bayreuth",
    "state": "Bayern",
    "zipCodes": "95444-95448",
    "region": "Oberfranken",
    "description": "In Bayreuth bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Bayreuth – Ihr Experte in Oberfranken",
    "seoKeywords": "Wärmepumpe Bayreuth, Heizung Bayreuth, Wärmepumpeninstallation Bayreuth"
  },
  {
    "name": "Gießen",
    "slug": "giessen",
    "state": "Hessen",
    "zipCodes": "35390-35398",
    "region": "Mittelhessen",
    "description": "In Gießen sind wir Ihr Partner für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Gießen – Heizen mit Zukunft",
    "seoKeywords": "Wärmepumpe Gießen, Heizung Gießen, Wärmepumpeninstallation Gießen"
  },
  {
    "name": "Jena",
    "slug": "jena",
    "state": "Thüringen",
    "zipCodes": "07743-07751",
    "region": "Ostthüringen",
    "description": "In Jena bieten wir nachhaltige Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Jena – Heizungsexperten in Thüringen",
    "seoKeywords": "Wärmepumpe Jena, Heizung Jena, Wärmepumpeninstallation Jena"
  },
  {
    "name": "Plauen",
    "slug": "plauen",
    "state": "Sachsen",
    "zipCodes": "08523-08529",
    "region": "Vogtland",
    "description": "In Plauen sind wir Ihr Experte für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Plauen – Ihr Partner im Vogtland",
    "seoKeywords": "Wärmepumpe Plauen, Heizung Plauen, Wärmepumpeninstallation Plauen"
  },
  {
    "name": "Marl",
    "slug": "marl",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "45768-45772",
    "region": "Ruhrgebiet",
    "description": "In Marl installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Marl – Moderne Heiztechnik im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Marl, Heizung Marl, Wärmepumpeninstallation Marl"
  },
  {
    "name": "Lüdenscheid",
    "slug": "luedenscheid",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "58507-58515",
    "region": "Sauerland",
    "description": "In Lüdenscheid bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Lüdenscheid – Heizen im Sauerland",
    "seoKeywords": "Wärmepumpe Lüdenscheid, Heizung Lüdenscheid, Wärmepumpeninstallation Lüdenscheid"
  },
  {
    "name": "Minden",
    "slug": "minden",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "32423-32429",
    "region": "Ostwestfalen",
    "description": "In Minden an der Weser sind wir Ihr Partner für Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Minden – Moderne Heiztechnik an der Weser",
    "seoKeywords": "Wärmepumpe Minden, Heizung Minden, Wärmepumpeninstallation Minden"
  },
  {
    "name": "Trier",
    "slug": "trier",
    "state": "Rheinland-Pfalz",
    "zipCodes": "54290-54296",
    "region": "Mosel",
    "description": "In Trier installieren wir nachhaltige Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Trier – Ihr Experte an der Mosel",
    "seoKeywords": "Wärmepumpe Trier, Heizung Trier, Wärmepumpeninstallation Trier"
  },
  {
    "name": "Villingen-Schwenningen",
    "slug": "villingen-schwenningen",
    "state": "Baden-Württemberg",
    "zipCodes": "78048-78056",
    "region": "Schwarzwald-Baar",
    "description": "In Villingen-Schwenningen bieten wir moderne Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Villingen-Schwenningen – Heizen im Schwarzwald",
    "seoKeywords": "Wärmepumpe Villingen-Schwenningen, Heizung Villingen-Schwenningen"
  },
  {
    "name": "Arnsberg",
    "slug": "arnsberg",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "59755-59821",
    "region": "Sauerland",
    "description": "In Arnsberg sind wir Ihr Partner für energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Arnsberg – Heizungsexperten im Sauerland",
    "seoKeywords": "Wärmepumpe Arnsberg, Heizung Arnsberg, Wärmepumpeninstallation Arnsberg"
  },
  {
    "name": "Bremerhaven",
    "slug": "bremerhaven",
    "state": "Bremen",
    "zipCodes": "27568-27580",
    "region": "Nordseeküste",
    "description": "In Bremerhaven installieren wir hocheffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Bremerhaven – Moderne Heiztechnik an der Nordsee",
    "seoKeywords": "Wärmepumpe Bremerhaven, Heizung Bremerhaven, Wärmepumpeninstallation Bremerhaven"
  },
  {
    "name": "Celle",
    "slug": "celle",
    "state": "Niedersachsen",
    "zipCodes": "29221-29229",
    "region": "Lüneburger Heide",
    "description": "In Celle bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Celle – Ihr Partner in der Lüneburger Heide",
    "seoKeywords": "Wärmepumpe Celle, Heizung Celle, Wärmepumpeninstallation Celle"
  },
  {
    "name": "Aschaffenburg",
    "slug": "aschaffenburg",
    "state": "Bayern",
    "zipCodes": "63739-63743",
    "region": "Unterfranken",
    "description": "In Aschaffenburg sind wir Ihr Experte für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Aschaffenburg – Heizen mit Zukunft",
    "seoKeywords": "Wärmepumpe Aschaffenburg, Heizung Aschaffenburg, Wärmepumpeninstallation Aschaffenburg"
  },
  {
    "name": "Lippstadt",
    "slug": "lippstadt",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "59555-59558",
    "region": "Ostwestfalen",
    "description": "In Lippstadt installieren wir energieeffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Lippstadt – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Lippstadt, Heizung Lippstadt, Wärmepumpeninstallation Lippstadt"
  },
  {
    "name": "Fulda",
    "slug": "fulda",
    "state": "Hessen",
    "zipCodes": "36037-36043",
    "region": "Osthessen",
    "description": "In Fulda bieten wir nachhaltige Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Fulda – Heizungsexperten in Osthessen",
    "seoKeywords": "Wärmepumpe Fulda, Heizung Fulda, Wärmepumpeninstallation Fulda"
  },
  {
    "name": "Dessau-Roßlau",
    "slug": "dessau-rosslau",
    "state": "Sachsen-Anhalt",
    "zipCodes": "06842-06849",
    "region": "Mittelelbe",
    "description": "In Dessau-Roßlau sind wir Ihr Partner für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Dessau-Roßlau – Ihr Experte an der Elbe",
    "seoKeywords": "Wärmepumpe Dessau, Heizung Dessau, Wärmepumpeninstallation Dessau"
  },
  {
    "name": "Sindelfingen",
    "slug": "sindelfingen",
    "state": "Baden-Württemberg",
    "zipCodes": "71063-71067",
    "region": "Region Stuttgart",
    "description": "In Sindelfingen installieren wir hocheffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Sindelfingen – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Sindelfingen, Heizung Sindelfingen, Wärmepumpeninstallation Sindelfingen"
  },
  {
    "name": "Rosenheim",
    "slug": "rosenheim",
    "state": "Bayern",
    "zipCodes": "83022-83026",
    "region": "Oberbayern",
    "description": "In Rosenheim bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Rosenheim – Heizen in Oberbayern",
    "seoKeywords": "Wärmepumpe Rosenheim, Heizung Rosenheim, Wärmepumpeninstallation Rosenheim"
  },
  {
    "name": "Landshut",
    "slug": "landshut",
    "state": "Bayern",
    "zipCodes": "84028-84036",
    "region": "Niederbayern",
    "description": "In Landshut sind wir Ihr Experte für nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Landshut – Moderne Heiztechnik in Niederbayern",
    "seoKeywords": "Wärmepumpe Landshut, Heizung Landshut, Wärmepumpeninstallation Landshut"
  },
  {
    "name": "Kempten",
    "slug": "kempten",
    "state": "Bayern",
    "zipCodes": "87435-87439",
    "region": "Allgäu",
    "description": "In Kempten im Allgäu installieren wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Kempten – Ihr Partner im Allgäu",
    "seoKeywords": "Wärmepumpe Kempten, Heizung Kempten, Wärmepumpeninstallation Kempten"
  },
  {
    "name": "Neubrandenburg",
    "slug": "neubrandenburg",
    "state": "Mecklenburg-Vorpommern",
    "zipCodes": "17033-17036",
    "region": "Mecklenburgische Seenplatte",
    "description": "In Neubrandenburg bieten wir energieeffiziente Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Neubrandenburg – Heizen in Mecklenburg",
    "seoKeywords": "Wärmepumpe Neubrandenburg, Heizung Neubrandenburg, Wärmepumpeninstallation Neubrandenburg"
  },
  {
    "name": "Weimar",
    "slug": "weimar",
    "state": "Thüringen",
    "zipCodes": "99423-99428",
    "region": "Mittelthüringen",
    "description": "In Weimar sind wir Ihr Partner für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Weimar – Heizungsexperten in der Kulturstadt",
    "seoKeywords": "Wärmepumpe Weimar, Heizung Weimar, Wärmepumpeninstallation Weimar"
  },
  {
    "name": "Dormagen",
    "slug": "dormagen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "41539-41541",
    "region": "Rhein-Kreis Neuss",
    "description": "In Dormagen installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Dormagen – Moderne Heiztechnik am Rhein",
    "seoKeywords": "Wärmepumpe Dormagen, Heizung Dormagen, Wärmepumpeninstallation Dormagen"
  },
  {
    "name": "Castrop-Rauxel",
    "slug": "castrop-rauxel",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "44575-44581",
    "region": "Ruhrgebiet",
    "description": "In Castrop-Rauxel bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Castrop-Rauxel – Heizen im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Castrop-Rauxel, Heizung Castrop-Rauxel, Wärmepumpeninstallation Castrop-Rauxel"
  },
  {
    "name": "Gladbeck",
    "slug": "gladbeck",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "45964-45968",
    "region": "Ruhrgebiet",
    "description": "In Gladbeck sind wir Ihr Experte für energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Gladbeck – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Gladbeck, Heizung Gladbeck, Wärmepumpeninstallation Gladbeck"
  },
  {
    "name": "Viersen",
    "slug": "viersen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "41747-41751",
    "region": "Niederrhein",
    "description": "In Viersen installieren wir nachhaltige Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Viersen – Ihr Partner am Niederrhein",
    "seoKeywords": "Wärmepumpe Viersen, Heizung Viersen, Wärmepumpeninstallation Viersen"
  },
  {
    "name": "Schwäbisch Gmünd",
    "slug": "schwaebisch-gmuend",
    "state": "Baden-Württemberg",
    "zipCodes": "73525-73529",
    "region": "Ostwürttemberg",
    "description": "In Schwäbisch Gmünd bieten wir moderne Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Schwäbisch Gmünd – Heizen in Ostwürttemberg",
    "seoKeywords": "Wärmepumpe Schwäbisch Gmünd, Heizung Schwäbisch Gmünd"
  },
  {
    "name": "Offenburg",
    "slug": "offenburg",
    "state": "Baden-Württemberg",
    "zipCodes": "77652-77656",
    "region": "Ortenau",
    "description": "In Offenburg sind wir Ihr Partner für hocheffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Offenburg – Moderne Heiztechnik in der Ortenau",
    "seoKeywords": "Wärmepumpe Offenburg, Heizung Offenburg, Wärmepumpeninstallation Offenburg"
  },
  {
    "name": "Norderstedt",
    "slug": "norderstedt",
    "state": "Schleswig-Holstein",
    "zipCodes": "22844-22851",
    "region": "Metropolregion Hamburg",
    "description": "In Norderstedt installieren wir energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Norderstedt – Heizen mit Zukunft",
    "seoKeywords": "Wärmepumpe Norderstedt, Heizung Norderstedt, Wärmepumpeninstallation Norderstedt"
  },
  {
    "name": "Neumünster",
    "slug": "neumuenster",
    "state": "Schleswig-Holstein",
    "zipCodes": "24534-24539",
    "region": "Mittelholstein",
    "description": "In Neumünster bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Neumünster – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Neumünster, Heizung Neumünster, Wärmepumpeninstallation Neumünster"
  },
  {
    "name": "Greifswald",
    "slug": "greifswald",
    "state": "Mecklenburg-Vorpommern",
    "zipCodes": "17487-17493",
    "region": "Vorpommern",
    "description": "In Greifswald sind wir Ihr Experte für nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Greifswald – Heizungsexperten in Vorpommern",
    "seoKeywords": "Wärmepumpe Greifswald, Heizung Greifswald, Wärmepumpeninstallation Greifswald"
  },
  {
    "name": "Bergisch Gladbach",
    "slug": "bergisch-gladbach",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "51427-51467",
    "region": "Bergisches Land",
    "description": "In Bergisch Gladbach installieren wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Bergisch Gladbach – Ihr Partner im Bergischen Land",
    "seoKeywords": "Wärmepumpe Bergisch Gladbach, Heizung Bergisch Gladbach"
  },
  {
    "name": "Friedrichshafen",
    "slug": "friedrichshafen",
    "state": "Baden-Württemberg",
    "zipCodes": "88045-88048",
    "region": "Bodensee",
    "description": "In Friedrichshafen am Bodensee bieten wir hocheffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Friedrichshafen – Heizen am Bodensee",
    "seoKeywords": "Wärmepumpe Friedrichshafen, Heizung Friedrichshafen, Wärmepumpeninstallation Friedrichshafen"
  },
  {
    "name": "Bad Homburg",
    "slug": "bad-homburg",
    "state": "Hessen",
    "zipCodes": "61348-61352",
    "region": "Taunus",
    "description": "In Bad Homburg vor der Höhe sind wir Ihr Partner für Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Bad Homburg – Moderne Heiztechnik im Taunus",
    "seoKeywords": "Wärmepumpe Bad Homburg, Heizung Bad Homburg, Wärmepumpeninstallation Bad Homburg"
  },
  {
    "name": "Wetzlar",
    "slug": "wetzlar",
    "state": "Hessen",
    "zipCodes": "35576-35586",
    "region": "Mittelhessen",
    "description": "In Wetzlar installieren wir energieeffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Wetzlar – Heizungsexperten in Mittelhessen",
    "seoKeywords": "Wärmepumpe Wetzlar, Heizung Wetzlar, Wärmepumpeninstallation Wetzlar"
  },
  {
    "name": "Stralsund",
    "slug": "stralsund",
    "state": "Mecklenburg-Vorpommern",
    "zipCodes": "18435-18439",
    "region": "Ostseeküste",
    "description": "In Stralsund bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Stralsund – Heizen an der Ostsee",
    "seoKeywords": "Wärmepumpe Stralsund, Heizung Stralsund, Wärmepumpeninstallation Stralsund"
  },
  {
    "name": "Kleve",
    "slug": "kleve",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "47533-47551",
    "region": "Niederrhein",
    "description": "In Kleve am Niederrhein sind wir Ihr Experte für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Kleve – Moderne Heiztechnik am Niederrhein",
    "seoKeywords": "Wärmepumpe Kleve, Heizung Kleve, Wärmepumpeninstallation Kleve"
  },
  {
    "name": "Gummersbach",
    "slug": "gummersbach",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "51643-51647",
    "region": "Oberbergischer Kreis",
    "description": "In Gummersbach installieren wir nachhaltige Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Gummersbach – Heizen im Bergischen",
    "seoKeywords": "Wärmepumpe Gummersbach, Heizung Gummersbach, Wärmepumpeninstallation Gummersbach"
  },
  {
    "name": "Wesel",
    "slug": "wesel",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "46483-46487",
    "region": "Niederrhein",
    "description": "In Wesel bieten wir moderne Wärmepumpen-Lösungen am Niederrhein.",
    "heroTitle": "Wärmepumpen in Wesel – Ihr Partner am Niederrhein",
    "seoKeywords": "Wärmepumpe Wesel, Heizung Wesel, Wärmepumpeninstallation Wesel"
  },
  {
    "name": "Kerpen",
    "slug": "kerpen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "50170-50171",
    "region": "Rhein-Erft-Kreis",
    "description": "In Kerpen sind wir Ihr Partner für energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Kerpen – Moderne Heiztechnik im Rhein-Erft-Kreis",
    "seoKeywords": "Wärmepumpe Kerpen, Heizung Kerpen, Wärmepumpeninstallation Kerpen"
  },
  {
    "name": "Grevenbroich",
    "slug": "grevenbroich",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "41515-41516",
    "region": "Rhein-Kreis Neuss",
    "description": "In Grevenbroich installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Grevenbroich – Heizen mit Zukunft",
    "seoKeywords": "Wärmepumpe Grevenbroich, Heizung Grevenbroich, Wärmepumpeninstallation Grevenbroich"
  },
  {
    "name": "Hürth",
    "slug": "huerth",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "50354-50355",
    "region": "Rhein-Erft-Kreis",
    "description": "In Hürth bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Hürth – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Hürth, Heizung Hürth, Wärmepumpeninstallation Hürth"
  },
  {
    "name": "Goslar",
    "slug": "goslar",
    "state": "Niedersachsen",
    "zipCodes": "38640-38644",
    "region": "Harz",
    "description": "In Goslar am Harz sind wir Ihr Experte für nachhaltige Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Goslar – Heizungsexperten im Harz",
    "seoKeywords": "Wärmepumpe Goslar, Heizung Goslar, Wärmepumpeninstallation Goslar"
  },
  {
    "name": "Unna",
    "slug": "unna",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "59423-59427",
    "region": "Hellweg",
    "description": "In Unna installieren wir moderne Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Unna – Moderne Heiztechnik am Hellweg",
    "seoKeywords": "Wärmepumpe Unna, Heizung Unna, Wärmepumpeninstallation Unna"
  },
  {
    "name": "Speyer",
    "slug": "speyer",
    "state": "Rheinland-Pfalz",
    "zipCodes": "67346-67354",
    "region": "Pfalz",
    "description": "In Speyer am Rhein sind wir Ihr Partner für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Speyer – Heizungsexperten in der Pfalz",
    "seoKeywords": "Wärmepumpe Speyer, Heizung Speyer, Wärmepumpeninstallation Speyer"
  },
  {
    "name": "Passau",
    "slug": "passau",
    "state": "Bayern",
    "zipCodes": "94032-94036",
    "region": "Niederbayern",
    "description": "In Passau installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Passau – Heizen an der Donau",
    "seoKeywords": "Wärmepumpe Passau, Heizung Passau, Wärmepumpeninstallation Passau"
  },
  {
    "name": "Freising",
    "slug": "freising",
    "state": "Bayern",
    "zipCodes": "85354-85356",
    "region": "Oberbayern",
    "description": "In Freising bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Freising – Moderne Heiztechnik in Oberbayern",
    "seoKeywords": "Wärmepumpe Freising, Heizung Freising, Wärmepumpeninstallation Freising"
  },
  {
    "name": "Straubing",
    "slug": "straubing",
    "state": "Bayern",
    "zipCodes": "94315-94327",
    "region": "Niederbayern",
    "description": "In Straubing sind wir Ihr Experte für energieeffiziente Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Straubing – Heizen in Niederbayern",
    "seoKeywords": "Wärmepumpe Straubing, Heizung Straubing, Wärmepumpeninstallation Straubing"
  },
  {
    "name": "Dachau",
    "slug": "dachau",
    "state": "Bayern",
    "zipCodes": "85221-85229",
    "region": "Oberbayern",
    "description": "In Dachau installieren wir nachhaltige Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Dachau – Moderne Heiztechnik",
    "seoKeywords": "Wärmepumpe Dachau, Heizung Dachau, Wärmepumpeninstallation Dachau"
  },
  {
    "name": "Bad Salzuflen",
    "slug": "bad-salzuflen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "32105-32108",
    "region": "Lippe",
    "description": "In Bad Salzuflen sind wir Ihr Experte für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Bad Salzuflen – Heizungsexperten in Lippe",
    "seoKeywords": "Wärmepumpe Bad Salzuflen, Heizung Bad Salzuflen, Wärmepumpeninstallation Bad Salzuflen"
  },
  {
    "name": "Schweinfurt",
    "slug": "schweinfurt",
    "state": "Bayern",
    "zipCodes": "97421-97424",
    "region": "Unterfranken",
    "description": "In Schweinfurt installieren wir nachhaltige Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Schweinfurt – Moderne Heiztechnik in Unterfranken",
    "seoKeywords": "Wärmepumpe Schweinfurt, Heizung Schweinfurt, Wärmepumpeninstallation Schweinfurt"
  },
  {
    "name": "Hof",
    "slug": "hof",
    "state": "Bayern",
    "zipCodes": "95028-95032",
    "region": "Oberfranken",
    "description": "In Hof bieten wir energieeffiziente Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Hof – Heizen in Oberfranken",
    "seoKeywords": "Wärmepumpe Hof, Heizung Hof, Wärmepumpeninstallation Hof"
  },
  {
    "name": "Nordhorn",
    "slug": "nordhorn",
    "state": "Niedersachsen",
    "zipCodes": "48527-48531",
    "region": "Grafschaft Bentheim",
    "description": "In Nordhorn installieren wir hocheffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Nordhorn – Heizen in der Grafschaft Bentheim",
    "seoKeywords": "Wärmepumpe Nordhorn, Heizung Nordhorn, Wärmepumpeninstallation Nordhorn"
  },
  {
    "name": "Meerbusch",
    "slug": "meerbusch",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "40667-40670",
    "region": "Rhein-Kreis Neuss",
    "description": "In Meerbusch bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Meerbusch – Moderne Heiztechnik am Rhein",
    "seoKeywords": "Wärmepumpe Meerbusch, Heizung Meerbusch, Wärmepumpeninstallation Meerbusch"
  },
  {
    "name": "Paderborn",
    "slug": "paderborn",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "33098-33106",
    "region": "Ostwestfalen",
    "description": "In Paderborn bieten wir moderne Wärmepumpen-Lösungen.",
    "heroTitle": "Wärmepumpen in Paderborn – Ihr Partner in Ostwestfalen",
    "seoKeywords": "Wärmepumpe Paderborn, Heizung Paderborn, Wärmepumpeninstallation Paderborn"
  },
  {
    "name": "Bamberg",
    "slug": "bamberg",
    "state": "Bayern",
    "zipCodes": "96047-96052",
    "region": "Oberfranken",
    "description": "In Bamberg installieren wir energieeffiziente Wärmepumpen-Systeme.",
    "heroTitle": "Wärmepumpen in Bamberg – Moderne Heiztechnik in Oberfranken",
    "seoKeywords": "Wärmepumpe Bamberg, Heizung Bamberg, Wärmepumpeninstallation Bamberg"
  },
  {
    "name": "Aalen",
    "slug": "aalen",
    "state": "Baden-Württemberg",
    "zipCodes": "73430-73434",
    "region": "Ostwürttemberg",
    "description": "In Aalen bieten wir professionelle Wärmepumpen-Installationen.",
    "heroTitle": "Wärmepumpen in Aalen – Heizen in Ostwürttemberg",
    "seoKeywords": "Wärmepumpe Aalen, Heizung Aalen, Wärmepumpeninstallation Aalen"
  },
  {
    "name": "Lünen",
    "slug": "luenen",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "44532-44536",
    "region": "Ruhrgebiet",
    "description": "In Lünen sind wir Ihr Experte für moderne Wärmepumpen.",
    "heroTitle": "Wärmepumpen in Lünen – Heizungsexperten im Ruhrgebiet",
    "seoKeywords": "Wärmepumpe Lünen, Heizung Lünen, Wärmepumpeninstallation Lünen"
  },
  {
    "name": "Dinslaken",
    "slug": "dinslaken",
    "state": "Nordrhein-Westfalen",
    "zipCodes": "46535-46539",
    "region": "Niederrhein",
    "description": "In Dinslaken installieren wir nachhaltige Wärmepumpen-Systeme am Niederrhein.",
    "heroTitle": "Wärmepumpen in Dinslaken – Moderne Heiztechnik am Niederrhein",
    "seoKeywords": "Wärmepumpe Dinslaken, Heizung Dinslaken, Wärmepumpeninstallation Dinslaken"
  }
];

export const nationalContact = {
  "phone": "08002800222",
  "phoneFormatted": "0800-2800-222",
  "phoneDisplay": "0800 2800 222",
  "email": "info@novatus-se.de",
  "description": "Kostenfrei aus allen deutschen Netzen"
};

// Helper-Funktion zum Finden einer Region
export const getCityBySlug = (slug) => {
  return cities.find(city => city.slug === slug);
};

// Helper-Funktion für Regions-Namen
export const getAllCitySlugs = () => {
  return cities.map(city => city.slug);
};
